export default "__VITE_PUBLIC_ASSET__d2550d87__"